import { Box } from '@mui/material'
import React, { FC } from 'react'

interface GradientProps {
  colors: string[]
  tall?: string
}

const GradientBox: FC<GradientProps> = ({ colors, tall }) => {
  const colores = colors.toString()

  return (
    <Box
      sx={{
        borderRadius: `${tall ? '5px' : '0px'}`,
        width: '90%',
        height: `${tall ?? '2vw'}`,
        backgroundImage: `linear-gradient(to right, ${colores})`,
        mb: 2
      }}
      id='gradient-colors'
    ></Box>
  )
}

export default GradientBox
